import { imgPlayerMenuPassLevel } from "@/shared/assets/img";

export default function PlayerMenuPassLevel() {
  return (
    <div
      className="h-[5.25rem] px-5 flex items-center gap-3.5 mt-2.5"
      style={{
        backgroundImage: `url(${imgPlayerMenuPassLevel})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="h-[2.75rem] aspect-square shrink-0 flex items-center justify-center">
        <img src="./svg/player-menu/shield.svg" alt="" className="h-full w-full" />
        <div className="absolute text-18 font-extrabold">0</div>
      </div>
      <div className="grow">
        <div className="text-12 font-extrabold uppercase">УРОВЕНЬ ПРОПУСКА</div>
        <div className="h-1.5 rounded-[1rem] relative overflow-clip mt-2">
          <div className="h-1.5 w-full grid grid-cols-10 gap-0.5 absolute">
            <div className="bg-accent-solid/50 h-full" />
            <div className="bg-accent-solid/50 h-full" />
            <div className="bg-accent-solid/50 h-full" />
            <div className="bg-accent-solid/50 h-full" />
            <div className="bg-accent-solid/50 h-full" />
            <div className="bg-accent-solid/50 h-full" />
            <div className="bg-accent-solid/50 h-full" />
            <div className="bg-accent-solid/50 h-full" />
            <div className="bg-accent-solid/50 h-full" />
            <div className="bg-accent-solid/50 h-full" />
          </div>
          <div
            className="h-1.5 w-full grid grid-cols-10 gap-0.5 absolute"
            style={{
              clipPath: `polygon(0% 0%, ${50}% 0%, ${50}% 100%, 0% 100%)`,
            }}
          >
            <div className="bg-accent-solid h-full" />
            <div className="bg-accent-solid h-full" />
            <div className="bg-accent-solid h-full" />
            <div className="bg-accent-solid h-full" />
            <div className="bg-accent-solid h-full" />
            <div className="bg-accent-solid h-full" />
            <div className="bg-accent-solid h-full" />
            <div className="bg-accent-solid h-full" />
            <div className="bg-accent-solid h-full" />
            <div className="bg-accent-solid h-full" />
          </div>
        </div>
        <div className="flex items-center justify-between mt-2">
          <div className="text-13 font-bold">
            <span className="text-accent-solid">600</span> / 1000
          </div>
          <div className="text-12 font-bold text-white/50 uppercase mt-1">ОЧКИ ОПЫТА</div>
        </div>
      </div>
    </div>
  );
}
